module.exports = __webpack_public_path__ + "img/major-02-stars-glow.28086502.svg";